import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  mainTitleDiv: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '15px',

    [theme.breakpoints.up('large')]: {
      paddingBottom: '24px',
    },
  },

  pageSubtitle: {
    fontSize: '14px',
    color: '#818C98',
    margin: '6px 0 0',
    fontWeight: 400,
    lineHeight: '100%',
  },

  mapPageHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    paddingBottom: '16px',

    [theme.breakpoints.up('large')]: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: '24px',
      paddingBottom: '20px',
    },
  },

  mapPageTitleBlock: {
    display: 'flex',
    flexDirection: 'column',
  },

  exitEditModeLink: {
    alignSelf: 'flex-start',
    marginTop: '8px',
    padding: 0,
    border: 'none',
    background: 'none',
    color: theme.palette.oceanBlue,
    fontSize: '13px',
    textDecoration: 'underline',
    cursor: 'pointer',
  },

  mapControlsBar: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginBottom: '16px',

    [theme.breakpoints.up('large')]: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      gap: '28px',
    },
  },

  mapControlsInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    flex: 1,
    minWidth: 0,

    [theme.breakpoints.up('large')]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '24px',
      paddingBottom: '10px',
    },
  },

  occupancyBlock: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    width: '100%',

    [theme.breakpoints.up('large')]: {
      width: 'auto',
      flexShrink: 0,
    },
  },

  occupancyText: {
    fontSize: '13px',
    color: '#5A6474',
    whiteSpace: 'nowrap',

    '& strong': {
      color: theme.palette.oceanBlue,
      fontWeight: 600,
    },
  },

  occupancyTrack: {
    display: 'block',
    flex: 1,
    minWidth: '80px',
    height: '6px',
    borderRadius: '3px',
    background: '#EDF0F5',
    overflow: 'hidden',

    [theme.breakpoints.up('large')]: {
      flex: 'none',
      width: '90px',
    },
  },

  occupancyFill: {
    display: 'block',
    height: '100%',
    borderRadius: '3px',
    background: theme.palette.oceanBlue,
    transition: 'width 0.4s ease',
  },

  myReservationCenter: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    margin: '0',
    gap: '20px',
  },

  mainPageContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    alignItems: 'center',

    [theme.breakpoints.up('extraLarge')]: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'unset',
    },
  },

  titleFont: {
    fontWeight: 400,
    color: theme.palette.black,
    fontSize: '24px',
    lineHeight: '100%',
    margin: '0',

    [theme.breakpoints.up('large')]: {
      fontSize: '30px',
    },
  },

  backButton: {
    backgroundColor: theme.palette.white,
    border: 0,
    outline: 'none',
    padding: '2.13vw',
    marginTop: '4.26vw',
    marginLeft: '4.26vw',
    float: 'left',

    [theme.breakpoints.up('medium')]: {
      padding: '1.04vw',
      marginTop: '2.08vw',
      marginLeft: '8.33vw',
    },
    [theme.breakpoints.up('tablet')]: {
      padding: '0.83vw',
      marginTop: '1.04vw',
      marginLeft: '6.77vw',
      float: 'unset',
    },
    [theme.breakpoints.up('large')]: {
      padding: '0.92vw',
      marginTop: '0.78vw',
      marginLeft: '10.07vw',
    },
    [theme.breakpoints.up('extraLarge')]: {
      padding: '0.55vw',
      marginTop: '0.69vw',
      marginLeft: '1.66vw',
    },
  },

  sidedTitle: {},

  backIcon: {
    width: '6.4vw',
    height: '6.4vw',

    [theme.breakpoints.up('medium')]: {
      width: '3.12vw',
      height: '3.12vw',
    },
    [theme.breakpoints.up('tablet')]: {
      width: '2.5vw',
      height: '2.5vw',
    },
    [theme.breakpoints.up('large')]: {
      width: '1.87vw',
      height: '1.87vw',
    },
    [theme.breakpoints.up('extraLarge')]: {
      width: '1.66vw',
      height: '1.66vw',
    },
  },

  navigationContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: 'fit-content',
    marginTop: 0,
    marginLeft: '4.26vw',
    height: '4.53vw',
    float: 'left',

    [theme.breakpoints.up('medium')]: {
      marginTop: 0,
      marginLeft: '13.54vw',
      height: '2.21vw',
    },
    [theme.breakpoints.up('tablet')]: {
      marginTop: '3.64vw',
      marginLeft: '1.66vw',
      height: '1.77vw',
    },
    [theme.breakpoints.up('large')]: {
      marginTop: '2.65vw',
      marginLeft: '1.25vw',
      height: '1.32vw',
    },
    [theme.breakpoints.up('extraLarge')]: {
      marginTop: '2.22vw',
      marginLeft: '1.66vw',
      height: '1.18vw',
    },
  },

  navigationFont: {
    margin: 0,
    fontWeight: 400,
    color: theme.palette.grey1,
    fontSize: '3.09vw',

    '&.actual': {
      fontWeight: 700,
      color: theme.palette.oceanBlue,
    },

    [theme.breakpoints.up('medium')]: {
      fontSize: '1.82vw',
    },
    [theme.breakpoints.up('tablet')]: {
      fontSize: '1.45vw',
    },
    [theme.breakpoints.up('large')]: {
      fontSize: '1.09vw',
    },
    [theme.breakpoints.up('extraLarge')]: {
      fontSize: '0.97vw',
    },
  },

  navigationIcon: {
    height: '3.73vw',
    width: '1.86vw',
    marginLeft: '0.38vw',
    marginTop: '0vw',
    marginRight: '0.38vw',

    [theme.breakpoints.up('medium')]: {
      height: '1.82vw',
      width: '0.91vw',
      marginLeft: '1.08vw',
      marginTop: '0.26vw',
      marginRight: '1.08vw',
    },
    [theme.breakpoints.up('tablet')]: {
      height: '1.45vw',
      width: '0.72vw',
      marginLeft: '0.83vw',
      marginTop: '0.20vw',
      marginRight: '0.83vw',
    },
    [theme.breakpoints.up('large')]: {
      height: '1.32vw',
      width: '0.54vw',
      marginLeft: '0.62vw',
      marginRight: '0.62vw',
      marginTop: 'unset',
    },
    [theme.breakpoints.up('extraLarge')]: {
      height: '1.18vw',
      width: '0.5vw',
      marginLeft: '0.55vw',
      marginRight: '0.55vw',
    },
  },

  blockedContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    marginLeft: '0vw',
    textAlign: 'center',

    [theme.breakpoints.up('medium')]: {
      marginLeft: '0vw',
    },
    [theme.breakpoints.up('tablet')]: {
      marginLeft: '0vw',
    },
    [theme.breakpoints.up('large')]: {
      marginLeft: '16vw',
    },
  },

  notFoundH1: {
    fontWeight: 700,
    fontSize: '100px',
    margin: 0,
    color: theme.palette.grey4,

    [theme.breakpoints.up('medium')]: {
      fontSize: '140px',
    },
  },

  notFoundH2: {
    fontSize: '18px',

    [theme.breakpoints.up('medium')]: {
      fontSize: '24px',
    },
  },

  notFoundIcon: {
    fill: theme.palette.grey4,
    height: '70px',

    [theme.breakpoints.up('medium')]: {
      height: '100px',
    },
  },

  blockedH1: {
    fontWeight: 700,
    fontSize: '7vw',
    margin: 0,
    marginLeft: '6vw',
    marginRight: '6vw',
    color: theme.palette.oceanBlue,

    [theme.breakpoints.up('medium')]: {
      fontSize: '6vw',
      margin: 0,
      marginLeft: '0vw',
      marginRight: '0vw',
    },
    [theme.breakpoints.up('tablet')]: {
      fontSize: '4vw',
      margin: 0,
      marginLeft: '0vw',
      marginRight: '0vw',
    },
    [theme.breakpoints.up('large')]: {
      fontSize: '3vw',
      margin: 0,
      marginLeft: '0vw',
      marginRight: '0vw',
    },
  },

  blockedH2: {
    fontSize: '4vw',
    marginLeft: '6vw',
    marginRight: '6vw',

    [theme.breakpoints.up('medium')]: {
      fontSize: '3vw',
      marginLeft: '0vw',
      marginRight: '0vw',
    },
    [theme.breakpoints.up('tablet')]: {
      fontSize: '1.8vw',
      marginLeft: '0vw',
      marginRight: '0vw',
    },
    [theme.breakpoints.up('large')]: {
      marginLeft: '0vw',
      marginRight: '0vw',
    },
  },

  pageContainer: {
    width: '100%',
    margin: '0 auto',

    [theme.breakpoints.up('large')]: {
      maxWidth: '1140px',
    },
  },

  notFundPageContainer: {
    width: '100%',
    height: 'calc(100vh - 150px)',
    textAlign: 'center',
    alignContent: 'center',

    [theme.breakpoints.up('large')]: {
      width: 'fit-content',
      margin: '0 auto',
    },
  },
}));